<template>
  <service-area-table :items="list" :loading="loading"></service-area-table>
</template>

<script>
import { mapState } from "vuex";

import ServiceAreaTable from "./ServiceAreaTable";

export default {
  components: {
    ServiceAreaTable,
  },
  computed: {
    ...mapState({
      list: state => state.dashboard.serviceArea.list,
      loading: state => state.dashboard.serviceArea.loading,
    }),
  },
};
</script>
